import {z} from 'zod'

import {RangeSettings} from '../../common/types'
import {Fields} from '../types'

import {ErrorCodes} from './errorCodes'

export const validateFieldRange = (
  value: number,
  settings: RangeSettings,
  field: Fields,
  path: string,
  ctx: z.RefinementCtx
) => {
  if (value < settings.min || value > settings.max) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [path],
      message: ErrorCodes[field].outOfRange
    })
  }

  if ((value - settings.min) % settings.step !== 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [path],
      message: ErrorCodes[field].invalidStep
    })
  }
}
